<template>
    <div class="left_panel design_studio_panel_pd my_design_new">
        <div>
            <div
                class="tools_headding select_catgory_headding w-100 heading-pd"
            >
                <h4 class="heading5">
                    <span id="my-design">{{
                        statusFilter === 0 ? "My Archive" : "My Designs"
                    }}</span>
                </h4>
                <a
                    href="javascript:;"
                    @click="closeMenu('designs')"
                    class="ml-auto"
                    title="Close"
                >
                    <img src="/maincss/images/tool_close.svg" alt="Close" />
                </a>
            </div>
            <div class="top-search_items mb-0">
                <div class="search_field position-relative mg-b-12">
                    <!-- <label class="s-r-3"> Search</label> -->
                    <img
                        src="/maincss/images/search-grey.svg"
                        class="search_icon"
                        alt=""
                    />
                    <input
                        type="text"
                        placeholder="Search Design"
                        v-model="design_search_query"
                        class="form-control"
                    />
                </div>
                <div class="filter_field">
                    <button
                        type="button"
                        class="filter-btn"
                        @click="toggleFilterPopup"
                    >
                        <img src="/maincss/images/filter.svg" alt="" />
                        Filter
                        <span
                            v-if="activeFilterCount > 0"
                            class="filter-badge"
                            >{{ activeFilterCount }}</span
                        >
                    </button>

                    <!-- Filter Popup -->
                    <div v-if="showFilterPopup" class="filter-popup">
                        <div class="filter-popup-header">
                            <h3 class="filter-popup-title">Filter</h3>
                            <button
                                type="button"
                                class="filter-clear-btn"
                                @click="clearFilters"
                            >
                                Clear
                            </button>
                        </div>

                        <div class="filter-popup-content">
                            <div class="filter-section">
                                <h4 class="filter-section-title">Categories</h4>
                                <div class="filter-options">
                                    <label
                                        v-for="category in all_category_list"
                                        :key="category.id"
                                        class="filter-option-label"
                                    >
                                        <input
                                            type="radio"
                                            name="category_filter"
                                            :value="category.id"
                                            v-model="selectedCategoryFilter"
                                            @change="onCategoryFilterChange"
                                        />
                                        <span class="filter-option-text">{{
                                            category.title
                                        }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="filter-popup-footer">
                            <button
                                type="button"
                                class="filter-apply-btn"
                                @click="applyFilters"
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my_design_fields d-none">
                <div class="col-md-6">
                    <fieldset class="form-group mt-0">
                        <v-select
                            label="title"
                            :reduce="(data) => data.id"
                            :options="all_category_list"
                            :placeholder="'Select Categories'"
                            v-model="listConfig.category_id"
                            @input="onChangeCategoryFilter"
                        ></v-select>
                    </fieldset>
                </div>
                <div class="col-md-6">
                    <fieldset class="form-group mt-0">
                        <v-select
                            label="attribute_set_name"
                            :reduce="(data) => data.id"
                            :options="all_attribute_sets_list"
                            :placeholder="'Select Attributes'"
                            v-model="listConfig.attribute_set_id"
                            @input="onChangeAttributeSetFilter"
                        ></v-select>
                    </fieldset>
                </div>
            </div>

            <!-- Design Listing -->
            <div
                v-if="saved_design_search().length > 0"
                class="categorys_open my-design my_design_new"
            >
                <div
                    v-for="(saved_designs, index) in saved_design_search()"
                    :key="index"
                    class="design_section"
                >
                    <div
                        @click="setNewDesign(saved_designs.id)"
                        class="cursor-pointer design-hover-pointer"
                        v-if="saved_designs.front_image"
                        :class="
                            current_design_id == saved_designs.id
                                ? 'design_block active_design'
                                : 'design_block'
                        "
                    >
                        <div class="design_top_main">
                            <h3
                                :attribute_sets="saved_designs.attribute_sets"
                                :category_ids="saved_designs.category_ids"
                            >
                                {{ saved_designs.name }}
                            </h3>
                            <div class="design_right_links">
                                <button
                                    v-if="statusFilter === 1"
                                    @click.stop="
                                        openArchiveModal(
                                            saved_designs.id,
                                            saved_designs.name
                                        )
                                    "
                                    title="Archive Design"
                                >
                                    <img
                                        src="/maincss/images/archive_icon.svg"
                                        alt="Archive"
                                    />
                                </button>
                                <button
                                    v-if="statusFilter === 0"
                                    @click.stop="
                                        unarchiveDesign(saved_designs.id)
                                    "
                                    title="Unarchive Design"
                                >
                                    <img
                                        src="/maincss/images/archive_icon.svg"
                                        alt="Unarchive"
                                    />
                                </button>
                                <button
                                    @click.stop="
                                        openDesignHistory(saved_designs.id)
                                    "
                                    title="Design History"
                                >
                                    <img
                                        src="/maincss/images/icons/design_history.svg"
                                        alt="Archive"
                                        title="Design History"
                                    />
                                </button>

                                <div
                                    class="delete_button"
                                    @click="
                                        $event.stopPropagation();
                                        deleteDesign(saved_designs.id);
                                    "
                                >
                                    <img
                                        src="/maincss/design-images/delete.svg"
                                        alt=""
                                        title="Delete Design"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div
                                class="col-md-3"
                                v-if="saved_designs.front_image"
                            >
                                <div class="design_items design-hover-pointer">
                                    <div class="items design-hover-pointer">
                                        <img
                                            :src="saved_designs.front_image"
                                            alt=""
                                            class="design-hover-pointer"
                                        />
                                    </div>
                                    <div class="bottom_design_items">
                                        <h5>Front</h5>
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.front_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-md-3"
                                v-if="saved_designs.back_image"
                            >
                                <div class="design_items design-hover-pointer">
                                    <div class="items design-hover-pointer">
                                        <img
                                            :src="saved_designs.back_image"
                                            alt=""
                                            class="design-hover-pointer"
                                        />
                                    </div>
                                    <div class="bottom_design_items">
                                        <h5>Back</h5>
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.back_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-md-3"
                                v-if="saved_designs.left_image"
                            >
                                <div class="design_items design-hover-pointer">
                                    <div class="items design-hover-pointer">
                                        <img
                                            :src="saved_designs.left_image"
                                            alt=""
                                            class="design-hover-pointer"
                                        />
                                    </div>
                                    <div class="bottom_design_items">
                                        <h5>Left</h5>
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.left_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-md-3"
                                v-if="saved_designs.right_image"
                            >
                                <div class="design_items design-hover-pointer">
                                    <div class="items design-hover-pointer">
                                        <img
                                            :src="saved_designs.right_image"
                                            alt=""
                                            class="design-hover-pointer"
                                        />
                                    </div>
                                    <div class="bottom_design_items">
                                        <h5>Right</h5>
                                        <div
                                            v-html="
                                                designColorsHtml(
                                                    saved_designs.right_color
                                                )
                                            "
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else
                class="serach s-r-12 blank_data_design_custom mrg_no_image"
            >
                {{
                    statusFilter === 0
                        ? "No archived designs."
                        : "No designs saved."
                }}
            </div>
        </div>

        <!-- Archive Design Modal -->
        <ArchiveDesignModal
            :designId="selectedDesignId"
            :designName="selectedDesignName"
            @archive-confirmed="handleArchiveConfirmed"
            ref="archiveModal"
        />

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import ArchiveDesignModal from "./ArchiveDesignModal.vue";

export default {
    name: "MyDesigns",
    props: {
        current_design_id: {
            type: [Number, String],
            default: null
        },
        design_tab_active: {
            type: Boolean,
            default: false
        },
        statusFilter: {
            type: Number,
            default: 1 // 1 = Active, 0 = Archived
        },
        productCategoryId: {
            type: [Number, String],
            default: null
        }
    },
    data() {
        return {
            isLoader: false,
            design_search_query: null,
            listConfig: {
                category_id: null,
                attribute_set_id: null
            },
            saved_design_list: [],
            all_category_list: [],
            all_attribute_sets_list: [],
            showFilterPopup: false,
            selectedCategoryFilter: "All",
            selectedDesignId: null,
            selectedDesignName: ""
        };
    },
    components: {
        ArchiveDesignModal
    },
    computed: {
        activeFilterCount() {
            let count = 0;
            if (
                this.selectedCategoryFilter &&
                this.selectedCategoryFilter !== "All"
            ) {
                count++;
            }
            return count;
        }
    },
    watch: {
        design_tab_active() {
            if (this.design_tab_active) {
                this.getAllSavedDesign();
            }
        },
        statusFilter() {
            // Reload designs when status filter changes
            this.getAllSavedDesign();
        },
        productCategoryId(newCategoryId) {
            // Auto-apply category filter when product category is received
            if (newCategoryId) {
                this.applyProductCategoryFilter(newCategoryId);
            }
        }
    },
    mounted() {
        if (this.all_category_list.length == 0) {
            this.getAllCategories().then(() => {
                // Apply product category filter if available after categories are loaded
                if (this.productCategoryId) {
                    this.applyProductCategoryFilter(this.productCategoryId);
                } else {
                    this.getAllSavedDesign();
                }
            });
        } else {
            // Apply product category filter if available
            if (this.productCategoryId) {
                this.applyProductCategoryFilter(this.productCategoryId);
            } else {
                this.getAllSavedDesign();
            }
        }
        if (this.all_attribute_sets_list.length == 0) {
            this.getAllAttributeSets();
        }
    },
    methods: {
        isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (error) {
                return false;
            }
        },
        getAllSavedDesign() {
            let _this = this;
            this.isLoader = true;
            let params = {
                ...this.listConfig,
                status: this.statusFilter
            };
            ApiService.query("/get-design-image-v2", {
                params: params
            })
                .then(({ data }) => {
                    _this.saved_design_list = data.design;
                    _this.isLoader = false;
                })
                .catch(({ response }) => {
                    console.log(response);
                    _this.isLoader = false;
                });
        },
        closeMenu() {
            this.$emit("close-design");
        },
        saved_design_search() {
            if (this.design_search_query) {
                return this.saved_design_list.filter((item) => {
                    return item.name
                        .toLowerCase()
                        .includes(this.design_search_query.toLowerCase());
                });
            } else {
                return this.saved_design_list || [];
            }
        },
        setNewDesign(design_id) {
            this.$emit("set-new-design", design_id);
        },
        deleteDesign(design_id) {
            if (confirm("Do you really want to delete?")) {
                this.isLoader = true;
                ApiService.delete("/delete-saved-design/" + design_id)
                    .then(() => {
                        this.$toast.success("Design deleted successfully", {
                            position: "top-right"
                        });
                        this.getAllSavedDesign();
                    })
                    .catch(({ response }) => {
                        console.log("Error Response", response);
                    });
            }
        },
        designColorsHtml(colors) {
            let output = "";
            if (colors == null) return output;
            if (colors !== null && colors !== "null" && this.isJSON(colors)) {
                let colorsParse = JSON.parse(colors).length
                    ? JSON.parse(colors)
                    : [];
                if (!colorsParse.length > 0) return output;

                let limitColorsArr =
                    colorsParse.length > 4
                        ? colorsParse.slice(0, 4)
                        : colorsParse;
                if (!Array.isArray(limitColorsArr)) return output;

                output += `<ul>`;
                limitColorsArr.forEach((element) => {
                    output += `<li style="background-color: ${element.hex};"></li>`;
                });
                if (colorsParse.length > 4) {
                    output += `<li class="more_color_link"><a href="javascript:;">+${
                        colorsParse.slice(4).length
                    }</a></li>`;
                }
                output += `</ul>`;
            }
            return output;
        },
        onChangeCategoryFilter() {
            this.listConfig.attribute_set_id = null;
            this.getAllAttributeSets();
            this.getAllSavedDesign();
        },
        onChangeAttributeSetFilter() {
            this.getAllSavedDesign();
        },
        getAllCategories() {
            return new Promise((resolve, reject) => {
                ApiService.get("/get-all-categories-list")
                    .then(({ data }) => {
                        this.all_category_list = data.categories;
                        this.all_category_list.unshift({
                            id: "All",
                            title: "All"
                        });
                        // Initialize selected category filter
                        if (this.listConfig.category_id) {
                            this.selectedCategoryFilter =
                                this.listConfig.category_id;
                        } else {
                            this.selectedCategoryFilter = "All";
                        }
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getAllAttributeSets() {
            let params = {
                attributes: ["id", "attribute_set_name"],
                category_id: this.listConfig.category_id || undefined
            };
            return new Promise((resolve, reject) => {
                ApiService.query("/get-attribute-sets", { params })
                    .then(({ data }) => {
                        this.all_attribute_sets_list = data.attributes;
                        this.all_attribute_sets_list.unshift({
                            id: "All",
                            attribute_set_name: "All"
                        });
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        toggleFilterPopup() {
            this.showFilterPopup = !this.showFilterPopup;
        },
        closeFilterPopup() {
            this.showFilterPopup = false;
        },
        clearFilters() {
            this.selectedCategoryFilter = "All";
            this.listConfig.category_id = null;
            this.getAllSavedDesign();
        },
        onCategoryFilterChange() {
            // Update when radio changes
        },
        applyFilters() {
            if (
                this.selectedCategoryFilter &&
                this.selectedCategoryFilter !== "All"
            ) {
                this.listConfig.category_id = this.selectedCategoryFilter;
            } else {
                this.listConfig.category_id = null;
            }
            this.getAllSavedDesign();
            this.closeFilterPopup();
        },
        openArchiveModal(designId, designName) {
            this.selectedDesignId = designId;
            this.selectedDesignName = designName;
            this.$refs.archiveModal.openModal();
        },
        handleArchiveConfirmed({ designId, archiveNotes }) {
            let _this = this;
            this.isLoader = true;
            ApiService.put(`/update-design-status/${designId}`, {
                status: 0, // 0 = Archived
                archive_note: archiveNotes
            })
                .then(({ data }) => {
                    _this.$toast.success(
                        data.message || "Design archived successfully",
                        {
                            position: "top-right"
                        }
                    );
                    _this.$refs.archiveModal.closeModal();
                    _this.getAllSavedDesign();
                })
                .catch(({ response }) => {
                    console.log("Error Response", response);
                    _this.$toast.error("Failed to archive design", {
                        position: "top-right"
                    });
                    _this.isLoader = false;
                });
        },
        unarchiveDesign(designId) {
            let _this = this;
            this.isLoader = true;
            ApiService.put(`/update-design-status/${designId}`, {
                status: 1, // 1 = Active
                archive_note: null
            })
                .then(({ data }) => {
                    _this.$toast.success(
                        data.message || "Design unarchived successfully",
                        {
                            position: "top-right"
                        }
                    );
                    _this.getAllSavedDesign();
                })
                .catch(({ response }) => {
                    console.log("Error Response", response);
                    _this.$toast.error("Failed to unarchive design", {
                        position: "top-right"
                    });
                    _this.isLoader = false;
                });
        },
        openDesignHistory(designId) {
            document.body.classList.add("my-design");
            this.$emit("open-design-history", designId);
        },
        applyProductCategoryFilter(categoryId) {
            // Wait for categories to be loaded before applying filter
            if (this.all_category_list.length === 0) {
                this.getAllCategories().then(() => {
                    this.setCategoryFilter(categoryId);
                });
            } else {
                this.setCategoryFilter(categoryId);
            }
        },
        setCategoryFilter(categoryId) {
            // Convert categoryId to string for comparison
            const categoryIdStr = String(categoryId);

            // Check if category exists in the list
            const categoryExists = this.all_category_list.some(
                (cat) => String(cat.id) === categoryIdStr
            );

            if (categoryExists) {
                this.selectedCategoryFilter = categoryIdStr;
                this.listConfig.category_id = categoryId;
                this.getAllSavedDesign();
            }
        }
    }
};
</script>

<style scoped>
.design-hover-pointer {
    cursor: pointer;
}
body.my-design{
    overflow: hidden !important;
}
</style>